// ======================================================================
// File Name       : LiveRegisterConfirmContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { getFormValues, isInvalid } from 'redux-form';
import * as UsageSettingLiveAction from '../../actions/UsageSettingLiveActions';
import ModalWrapper from '../../components/modal/ModalWrapper';
import LiveReservedDetailInfo from '../../components/usageSettingLive/LiveReservedDetailInfo';
import LiveReservedDetailUserList from '../../components/usageSettingLive/LiveReservedDetailUserList';
import LiveReservedUserAttributeList from '../../components/usageSettingLive/LiveReservedUserAttributeList';
import { MODE } from '../../constants/index';
import { LIVE_RESERVED_LIST } from '../../constants/PathConstants';
import { USER_ATTRIBUTE_TYPE } from '../../constants/UserAttributeConstants';

let okBtnClick = false;

class LiveRegisterConfirmContainer extends React.Component {
  constructor(props) {
    super(props);
    this.getModalOptions = this.getModalOptions.bind(this);
    this.registerLiveReservation = this.registerLiveReservation.bind(this);
    this.createParams = this.createParams.bind(this);
    this.createParamsEdit = this.createParamsEdit.bind(this);
  }

  registerLiveReservation() {
    const { invalid, isEdit } = this.props;
    if (invalid) {
      return;
    }
    const params = isEdit ? this.createParamsEdit() : this.createParams();
    this.props.hideModal();
    if (!okBtnClick) {
      okBtnClick = true;
      if (isEdit) {
        this.props.dispatch(UsageSettingLiveAction.editLiveReservation(params)).then((error) => {
          okBtnClick = false;
          if (!error) {
            this.props.history.push(LIVE_RESERVED_LIST);
          }
        });
      } else {
        this.props.dispatch(UsageSettingLiveAction.registerLiveReservation(params)).then((error) => {
          okBtnClick = false;
          if (!error) {
            this.props.history.push(LIVE_RESERVED_LIST);
          }
        });
      }
    }
  }

  createParamsEdit() {
    const { invalid, formValues, userAttributeList, storedEdittingUsers } = this.props;
    const paramLiveReserved = {};
    paramLiveReserved.editType = MODE.EDIT_MODE;
    const liveInfo = {};
    liveInfo.liveSecernId = formValues.liveSecernId;
    formValues.liveName && (liveInfo.liveName = formValues.liveName);
    formValues.liveStartFrom &&
      (liveInfo.liveStartFrom = moment(formValues.liveStartFrom).format(
        'YYYY-MM-DD HH:mm',
      ));
    formValues.liveStartTo &&
      (liveInfo.liveStartTo = moment(formValues.liveStartTo).format('YYYY-MM-DD HH:mm'));
    !isNaN(parseInt(formValues.liveFormat, 10)) && (liveInfo.liveFormat = formValues.liveFormat);
    formValues.selectedUserId && (liveInfo.organizerUserSecernId = formValues.selectedUserId);
    paramLiveReserved.liveInfo = liveInfo;

    const paramLiveUserRelation = {};
    if (formValues.storedEdittingUserList && storedEdittingUsers && storedEdittingUsers.allSecernIds) {
      const storedEdittingUserList = Object.keys(formValues.storedEdittingUserList);
      const deletingUsers = storedEdittingUsers.allSecernIds.reduce((acc, cur) => {
        if (cur && storedEdittingUserList.indexOf(cur) < 0) {
          acc.push(cur);
        }
        return acc;
      }, []);
      const newUsers = storedEdittingUserList.reduce((acc, cur) => {
        if (cur) {
          if (storedEdittingUsers.allSecernIds.indexOf(cur) < 0) {
            acc.push(cur);
          }
        }
        return acc;
      }, []);
      paramLiveUserRelation.deletingUsers = deletingUsers;
      paramLiveUserRelation.newUsers = newUsers;
    }
    const paramUserAttributes = {};
    paramUserAttributes.userAttributeType = USER_ATTRIBUTE_TYPE.LIVE;
    paramUserAttributes.userAttributeList = userAttributeList;
    return { paramLiveReserved, paramLiveUserRelation, paramUserAttributes };
  }

  createParams() {
    const { invalid, formValues, userAttributeList } = this.props;
    const paramLiveReserved = {};
    paramLiveReserved.editType = MODE.NEW_MODE;
    const liveInfo = {};
    formValues.liveName && (liveInfo.liveName = formValues.liveName);
    formValues.liveStartFrom &&
      (liveInfo.liveStartFrom = moment(formValues.liveStartFrom).format(
        'YYYY-MM-DD HH:mm',
      ));
    formValues.liveStartTo &&
      (liveInfo.liveStartTo = moment(formValues.liveStartTo).format('YYYY-MM-DD HH:mm'));
    !isNaN(parseInt(formValues.liveFormat, 10)) && (liveInfo.liveFormat = formValues.liveFormat);
    formValues.selectedUserId && (liveInfo.organizerUserSecernId = formValues.selectedUserId);
    paramLiveReserved.liveInfo = liveInfo;

    const paramLiveUserRelation = {};
    paramLiveUserRelation.editType = MODE.NEW_MODE;
    if (formValues.storedEdittingUserList && Object.keys(formValues.storedEdittingUserList).length) {
      paramLiveUserRelation.liveInfo = {};
      paramLiveUserRelation.liveInfo.userList = Object.keys(formValues.storedEdittingUserList);
    }
    const paramUserAttributes = {};
    paramUserAttributes.userAttributeType = USER_ATTRIBUTE_TYPE.LIVE;
    paramUserAttributes.userAttributeList = userAttributeList;
    return { paramLiveReserved, paramLiveUserRelation, paramUserAttributes };
  }

  getModalOptions() {
    return {
      title: '',
      footerBtns: [
        { name: 'キャンセル', onClick: this.props.hideModal },
        {
          name: 'OK',
          onClick: this.registerLiveReservation,
          variant: 'primary',
        },
      ],
    };
  }

  render() {
    const { formValues, edittingUsers, storedUserList, userAttributeList } = this.props;
    return (
      <ModalWrapper
        temporaryHide={''}
        {...this.getModalOptions()}
        hideModal={this.props.hideModal}
        title="ライブ情報の詳細"
        fixedHeight={false}
      >
        <div>
          <LiveReservedDetailInfo {...formValues} storedUserList={storedUserList} />
          <LiveReservedDetailUserList {...formValues} userLiveRelationList={edittingUsers} />
          <LiveReservedUserAttributeList userAttributeList={userAttributeList} />
        </div>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { storedUserList } = state.user;
  const { edittingUsers, storedEdittingUsers } = state.usageSettingLive;
  const formValues = getFormValues('liveReservedRegisterForm')(state);
  let userAttributeList = [];
  if (formValues && formValues.userAttributes && formValues.userAttributes.length) {
    userAttributeList = Object.keys(formValues.userAttributes).reduce((acc, cur) => {
      const userAttribute = formValues.userAttributes[cur];
      const userAttributeKeyNum = parseInt(cur, 10) + 1;
      acc.push({ userAttribute, userAttributeKeyNum });
      return acc;
    }, []);
  }
  return {
    storedUserList,
    edittingUsers,
    storedEdittingUsers,
    invalid: isInvalid('liveReservedRegisterForm')(state),
    formValues,
    userAttributeList,
  };
};

export default connect(mapStateToProps)(LiveRegisterConfirmContainer);
